// extracted by mini-css-extract-plugin
module.exports = {"label":"DatePicker_label__3KycZ"};